import Navbar from "../Navbar/Navbar";
import InputPage from "../InputPage/Inputpage";
import Footer from "../Footer/Footer";

function HomePage() {
  return (
    <div>
      <Navbar/>
      <InputPage/>
      <Footer/>
    </div>
  );
}

export default HomePage